import React from 'react';
import { Badge } from 'react-bootstrap';
import i18next from 'i18next';
import '../../styles/status-badge.css';
import { NotificationRecipientStatus, notificationRecipientStatusLabel } from './constants';

/** Χρώμα badge ανά κατάσταση παραλήπτη ενημέρωσης */
function colorVariant(statusId?: number): string {
  switch (statusId) {
    case NotificationRecipientStatus.NoEmail:
      return 'bg-warning';
    case NotificationRecipientStatus.Queued:
      return 'bg-info';
    case NotificationRecipientStatus.Failed:
      return 'bg-danger';
    case NotificationRecipientStatus.Sent:
      return 'bg-primary';
    case NotificationRecipientStatus.Responded:
      return 'bg-success';
    case NotificationRecipientStatus.TokenExpired:
      return 'bg-dark';
    default:
      return 'bg-secondary';
  }
}

export const NotificationRecipientStatusBadge = ({ statusId }: { statusId?: number }) => {
  const label = notificationRecipientStatusLabel(statusId);
  return (
    <Badge
      pill={true}
      className={`${colorVariant(statusId)} badge-status min-w-100 text-white align-middle`}
      style={{
        minWidth: '134px',
        textAlign: 'center',
        padding: '4px 0px 5px 8px',
      }}
    >
      {label ? i18next.t(label) : '---'}&nbsp;&nbsp;
    </Badge>
  );
};
